module.exports = __webpack_public_path__ + "static/media/th-list.8377489c.svg";